module.exports = __webpack_public_path__ + "static/img/006 5.be725809.jpg";